import React from 'react';
import PropTypes from 'prop-types';

// components
import DibsLogoIcon from 'dibs-vg/dist/react/logo';

// styles
import styles from './PdpRespPrintHeader.scss';

function PdpRespPrintHeader(props) {
    return (
        <div className={styles.wrap}>
            <DibsLogoIcon className={styles.logo} />
            <p className={styles.itemId}>{props.itemId}</p>
        </div>
    );
}

PdpRespPrintHeader.propTypes = {
    itemId: PropTypes.string.isRequired,
};

export default PdpRespPrintHeader;
